module.exports = __webpack_public_path__ + "img/people.5efd55ec.png";